"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNodeIds = createNodeIds;
const browser_rum_core_1 = require("@datadog/browser-rum-core");
function createNodeIds() {
    const nodeIds = new WeakMap();
    let nextNodeId = 1 /* NodeIdConstants.FIRST_ID */;
    const get = (node) => nodeIds.get(node);
    return {
        assign: (node) => {
            // Try to reuse any existing id.
            let nodeId = get(node);
            if (nodeId === undefined) {
                nodeId = nextNodeId++;
                nodeIds.set(node, nodeId);
            }
            return nodeId;
        },
        get,
        areAssignedForNodeAndAncestors: (node) => {
            let current = node;
            while (current) {
                if (get(current) === undefined && !(0, browser_rum_core_1.isNodeShadowRoot)(current)) {
                    return false;
                }
                current = (0, browser_rum_core_1.getParentNode)(current);
            }
            return true;
        },
    };
}
//# sourceMappingURL=nodeIds.js.map